import React, { useEffect, useState } from 'react';

import { firestore } from '../../../../../firebase';

import DeleteGeneratedTeams from '../Templates/DeleteGeneratedTeams';
import SaveGeneratedTeams from '../Templates/SaveGeneratedTeams';
import TeamDrawPlayers from '../Templates/TeamDrawPlayers'
import UpdateGeneratedTeams from '../Templates/UpdateGeneratedTeams';

function RandomTeamsRoundFirebase({id, roundId, players, draw, requestCount, setRequestCount, round}) {

    const [randomArray, setRandomArray] = useState([]);
    const [playersDraw, setPlayersDraw] = useState(players);
    const [teamDraw, setTeamDraw] = useState();
    const [teamDrawId, setTeamDrawId] = useState("");

    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    const [numPlayersTeam, setNumPlayersTeam] = useState(round.players_per_team);
    const [numTeams, setNumTeams] = useState(round.num_teams)

    const [show, setShow] = useState(false);
    const [updateCount, setUpdateCount] = useState(0);

    useEffect(() => {

        if (players) {
            let i, j, k;
            for (i = players.length -1; i > 0; i--) {
                j = Math.floor(Math.random() * i)
                k = players[i]
                players[i] = players[j]
                players[j] = k
            }
            setRandomArray(players)
            setPlayersDraw(players)
            //console.log(players, "Random players")
            
        }

    }, [id, roundId, players])

    useEffect(() => {

        try {
            const teamsRoundRef = firestore.collection("hostcup").doc(id).collection("rounds").doc(roundId).collection("teams");
            teamsRoundRef.where("draw", "==", draw).onSnapshot(({docs}) => {
                const team = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });

                if (team && team[0] && team[0].teams) {
                    setPlayersDraw(team[0].teams)
                    setTeamDraw(team[0]);
                    setTeamDrawId(team[0].id);
                }

            })
        } catch (error) {
            console.log(error)
        }

    }, [message, updateCount, players])

    function toggle() {
        if (show) {
            setShow(false);
        } else {
            setShow(true);
        }
    }

    return (
        <div>
            <h2>/ Random Teams Round </h2>
            {randomArray.length && (
                <React.Fragment>
                    <hr />
                    <div style={{cursor: "pointer"}} onClick={toggle} className="card card-header">
                        <div>Nytrekt lag (Ikke lagret) <span className="float-right"><i className={`fas fa-chevron-${show ? "down" : "up"}`}></i></span></div>
                    </div>
                    {show && (
                        <React.Fragment>
                            {!randomArray.length && <div className="alert alert-danger">Fant ikke spillertabell</div>}
                            <TeamDrawPlayers 
                                draw={randomArray} 
                                type="not_saved" 
                                numTeams={numTeams} 
                                playersCount={randomArray.length} 
                                playersPerTeam={numPlayersTeam} 
                            />
                        </React.Fragment>
                        
                    )}

                </React.Fragment>
            )}


            <hr />
            {!teamDraw && (
                <SaveGeneratedTeams 
                    hostcupId={id} 
                    roundId={roundId} 
                    draw={draw} 
                    requestCount={requestCount}
                    setRequestCount={setRequestCount} 
                    playersDraw={randomArray} 
                    round={round}
                />
            )}
            {teamDraw && teamDrawId && (
                <React.Fragment>
                    <UpdateGeneratedTeams 
                        id={id} 
                        roundId={roundId} 
                        teamDraw={teamDraw} 
                        requestCount={requestCount} 
                        setRequestCount={setRequestCount} 
                        updateCount={updateCount}
                        setUpdateCount={setUpdateCount}
                    />
                    <DeleteGeneratedTeams 
                        hostcupId={id} 
                        roundId={roundId} 
                        teamDrawId={teamDrawId} 
                        setTeamDraw={setTeamDraw}
                    />
                </React.Fragment>

            )}


        </div>
    )

}
export default RandomTeamsRoundFirebase